import React, { useState } from "react";
// import { usePostHog } from "posthog-js/react";
import posthog from "posthog-js";
import lostTheWay from "../../../assets/LostTheWay.png";
import anxiety from "../../../assets/Anxiety.png";
import lookingForSomething from "../../../assets/LookingForSomething.png";
import connection from "../../../assets/Connection.png";
import PersonalGrowth from "../../../assets/PersonalGrowth.png";

const moods = [
  {
    id: "torn",
    text: "I'm Torn",
    subtext: "Two roads.  One brain.  Zero clarity.",
    image: lostTheWay,
  },
  {
    id: "changing",
    text: "I'm Changing",
    subtext: "Not who I was. Not sure who I'm becoming.",
    image: anxiety,
  },
  {
    id: "stuck",
    text: "I'm Stuck Again",
    subtext: "Same loop, new day. How do I break this?",
    image: lookingForSomething,
  },
  {
    id: "let go",
    text: "I Can't Let It Go",
    subtext: "That thing they said. That thing I felt. Still stuck in me.",
    image: connection,
  },
  {
    id: "more",
    text: "I'm Ready for More",
    subtext:
      "Growth, clarity, purpose — I just don't want to play small anymore.",
    image: PersonalGrowth,
  },
  {
    id: "other",
    text: "Something else",
    subtext: "I can't name right now",
  },
];

const WhatAreYouInMoodForToday = ({ onClose }) => {
  const [selectedMood, setSelectedMood] = useState(null);

  const handleMoodSelection = (mood) => {
    setSelectedMood(mood.id);
    console.log(posthog.capture("mood_selected", { mood: mood.id }));
    console.log("Mood selected:", mood.id);
  };

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 backdrop-blur-md flex justify-center items-center z-50 font-gotham">
      <div className="bg-white w-[90vw] max-w-[1000px] h-auto max-h-[820px] rounded-xl p-4 sm:p-6 lg:p-4 flex flex-col shadow-xl relative">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 lg:gap-2 mb-4 md:mb-6 shrink-0">
          <h2 className="text-lg sm:text-2xl md:text-3xl lg:text-3xl font-semibold text-[#323232] font-quattrocento">
            What are you feeling today?
          </h2>
          <button
            className={`bg-[#54B0AF] hover:bg-teal-600 text-sm sm:text-base lg:text-lg font-medium px-6 py-2 rounded-full font-gotham shadow-md transition-all disabled:bg-[#F5F5F5] disabled:cursor-not-allowed whitespace-nowrap ${
              selectedMood ? "text-[#ffffff]" : "text-[#AAAAAA]"
            }`}
            onClick={() => onClose(selectedMood)}
            disabled={!selectedMood}
          >
            Let's Begin!
          </button>
        </div>

        {/* Mood Grid */}
        <div className="flex-1 overflow-y-auto lg:overflow-visible grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6 scrollbar-hide">
          {moods.map((mood) => (
            <div
              key={mood.id}
              className={`relative p-3 w-full max-w-[350px] mx-auto h-[200px] sm:h-[240px] lg:h-[200px] xl:h-[220px] md:h-[250px] sm:p-4 border-2 rounded-2xl cursor-pointer transition-all duration-200 hover:shadow-md hover:border-[#54B0AF] ${
                selectedMood === mood.id
                  ? "border-[#54B0AF]"
                  : "border-[#E3E3E3]"
              } ${!mood.image ? "flex items-center justify-center" : ""}`}
              onClick={() => handleMoodSelection(mood)}
            >
              {/* Radio Button */}
              <div className="absolute top-3 left-3 z-10">
                <div
                  className={`w-4 h-4 rounded-full border-[1.5px] ${
                    selectedMood === mood.id
                      ? "border-[#54B0AF] ring-2 ring-[#54B0AF]"
                      : "border-gray-300"
                  }`}
                >
                  {selectedMood === mood.id && (
                    <div className="w-2 h-2 bg-[#54B0AF] rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                  )}
                </div>
              </div>

              {mood.image ? (
                <>
                  {/* Image */}
                  <div className="flex justify-center pb-1 sm:pb-2">
                    <img
                      src={mood.image}
                      alt={mood.text}
                      className="w-[140px] h-[100px] sm:w-[160px] sm:h-[120px] lg:w-[140px] lg:h-[110px] xl:w-[150px] xl:h-[120px] lg:-translate-y-[5px] object-contain"
                    />
                  </div>

                  {/* Text */}
                  <div
                    className={`text-center absolute bottom-0 left-0 right-0 w-full rounded-bl-xl rounded-br-xl h-[80px] sm:h-[90px] xl:h-[90px] flex flex-col justify-center px-3 py-2 sm:py-2 ${
                      selectedMood === mood.id
                        ? "border-[#54B0AF] bg-[#54B0AF] text-white"
                        : "border-t border-[#E3E3E3] bg-[#ffffff]"
                    }`}
                  >
                    <h3
                      className={`text-sm sm:text-base md:text-lg lg:text-base font-medium mb-1 sm:mb-1 font-gotham ${
                        selectedMood === mood.id
                          ? "text-white"
                          : "text-[#323232]"
                      }`}
                    >
                      {mood.text}
                    </h3>
                    <p
                      className={`text-xs sm:text-sm md:text-sm lg:text-sm leading-snug font-normal font-gotham ${
                        selectedMood === mood.id
                          ? "text-white"
                          : "text-[#323232]"
                      }`}
                    >
                      {mood.subtext}
                    </p>
                  </div>
                </>
              ) : (
                // For "Something else"
                <div className="text-center px-3 py-4">
                  <h3
                    className={`text-base sm:text-lg md:text-xl lg:text-lg font-medium mb-2 font-gotham ${
                      selectedMood === mood.id
                        ? "text-[#54B0AF]"
                        : "text-[#323232]"
                    }`}
                  >
                    {mood.text}
                  </h3>
                  <p
                    className={`text-xs sm:text-sm md:text-base lg:text-sm leading-relaxed font-normal font-gotham ${
                      selectedMood === mood.id
                        ? "text-[#323232]"
                        : "text-[#323232]"
                    }`}
                  >
                    {mood.subtext}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatAreYouInMoodForToday;

// before 23-07-2025

// import React, { useState } from "react";
// import feeling_sad from "../../../assets/feeling_sad.png";
// import feeling_anxious from "../../../assets/feeling_anxious.png";
// import feeling_driven from "../../../assets/feeling_driven.png";
// import { useEffect } from "react";
// import { usePostHog } from "posthog-js/react";
// import posthog from "posthog-js";

// const moods = [
//   { id: "sad", text: "I'm feeling sad", image: feeling_sad },
//   { id: "anxious", text: "I'm feeling anxious", image: feeling_anxious },
//   {
//     id: "driven",
//     text: "I'm feeling driven to achieve a goal",
//     image: feeling_driven,
//   },
// ];

// const WhatAreYouInMoodForToday = ({ onClose }) => {
//   const [selectedMood, setSelectedMood] = useState(null);
//   const handleMoodSelection = (mood) => {
//     setSelectedMood(mood.id);
//     // Capture the mood event after the mood is selected
//     // posthog.capture("mood_selected", { mood: mood.id });
//     console.log(posthog.capture("mood_selected", { mood: mood.id }));
//     console.log("Mood selected:", mood.id);
//   };

//   return (
//     <div className="fixed inset-0 bg-gray-700 bg-opacity-50   backdrop-blur-md flex justify-center items-center z-50 font-gotham">
//       <div className="bg-white w-[90vw] max-w-5xl h-auto rounded-xl p-4 sm:p-8 flex flex-col shadow-xl relative">
//         {/* text */}
//         <h2 className="text-xl sm:text-3xl lg:text-4xl font-semibold text-center mb-4 md:mb-12 font-quattrocento">
//           What are you feeling today?
//         </h2>

//         <div className="flex flex-col sm:flex-row justify-center  items-stretch gap-4 px-2 sm:px-4 overflow-y-auto max-h-[80vh] sm:max-h-none scroll-smooth overscroll-contain">
//           {moods.map((mood) => (
//             <div
//               key={mood.id}
//               className={`relative md:p-2 border-2 rounded-2xl shadow-md cursor-pointer transition-all flex flex-col items-center text-center w-full sm:w-1/3 hover:border-[#54B0AF] ${
//                 selectedMood === mood.id
//                   ? "border-[#54B0AF] ring-2 ring-[#54B0AF]"
//                   : "border-gray-300"
//               }`}
//               onClick={() => handleMoodSelection(mood)}
//             >
//               <img
//                 src={mood.image}
//                 alt={mood.text}
//                 className="w-40 h-24 md:w-full md:h-auto object-contain mb-1 md:mb-3"
//               />
//               <p className="text-lg md:text-sm lg:text-xl font-medium h-16 font-gotham">
//                 {mood.text}
//               </p>

//               {selectedMood === mood.id && (
//                 <div className="absolute top-2 right-2 w-5 h-5 bg-[#54B0AF] rounded-full flex items-center justify-center">
//                   <div className="w-2 h-2 bg-white rounded-full" />
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Confirm Button */}
//         <div className="w-full mt-6 flex justify-end px-4">
//           <button
//             className="bg-[#54B0AF] hover:bg-teal-600 text-white text-lg sm:text-xl font-medium px-6 py-2 rounded-full shadow-md transition-all disabled:bg-gray-400 disabled:cursor-not-allowed"
//             onClick={() => onClose(selectedMood)}
//             disabled={!selectedMood}
//           >
//             Let's Begin
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhatAreYouInMoodForToday;
